import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IconTitleTextTooltip} from "../icon-title-text/icon-title-text.tooltip";
import {IconContainerBox} from "./boxes/icon-container.box";
import {IOSAddToHomeShareIconBox} from "./boxes/ios-add-to-home-share-icon.box";
import { MessageBodyContainerBox, MessageBodyBoldContainerBox } from "./boxes/message-body-container.box";

export interface IosAddToHomeScreenComponentProps {
    brandName: string;

    onClicked();
}

export class IosAddToHomeScreenComponent extends OrbitComponent<IosAddToHomeScreenComponentProps> {

    render() {
        const translationService = this.services.translation;

        const logoIcon = this.services.theme.currentTheme.images.appIcon.toString();
        const iosShareIcon = this.services.theme.currentTheme.images.iosShare.toString();

        const body = <MessageBodyContainerBox>
            {translationService.translate("PWA_QUICK_LAUNCH", {BRAND: this.props.brandName})}
            <div>
                {translationService.translate("PWA_TAP")}
                <IOSAddToHomeShareIconBox src={iosShareIcon} alt="Share"/>
                <MessageBodyBoldContainerBox>
                    {translationService.translate("PWA_ADD_TO_HOME_SCREEN")}
                </MessageBodyBoldContainerBox>
            </div>
        </MessageBodyContainerBox>;

        const icon = <IconContainerBox src={logoIcon.toString()} alt="Add to home screen" />;

        return <IconTitleTextTooltip
            icon={icon}
            text={body}
            onClick={this.props.onClicked}
        />
    }
}
